import { render, staticRenderFns } from "./ProductDerivedEntityForm.vue?vue&type=template&id=71879f95&scoped=true"
import script from "./ProductDerivedEntityForm.vue?vue&type=script&lang=js"
export * from "./ProductDerivedEntityForm.vue?vue&type=script&lang=js"
import style0 from "./ProductDerivedEntityForm.vue?vue&type=style&index=0&id=71879f95&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71879f95",
  null
  
)

export default component.exports